import { Logger } from '@west-australian-newspapers/typescript-log'
import {
    loadRrmeOfferGroupFromApi,
    offerGroups,
} from '../../subscription-offers/SubscriptionOffers'

export async function initSubscriptionOffers(
    publicationId: string,
    log: Logger,
    variant?: string,
    config?: { subscriptionOfferApi?: string },
) {
    const loadRrmePackagePromises = offerGroups.map((offerGroup) =>
        loadRrmeOfferGroupFromApi(
            publicationId,
            log,
            offerGroup,
            variant,
            config,
        ),
    )

    await Promise.allSettled(loadRrmePackagePromises)
}
